module.exports = __webpack_public_path__ + "static/img/productimg1.3ea7c707.png";